<template>
  <button
    @click="() => clickHandler()"
    class="frisbuy-button-arrow"
    :class="[`--${direction}`, `--${mode}`]"
  >
    <svg
      width="12.00503"
      height="23.010099"
      viewBox="0 0 12.00503 23.010099"
      version="1.1"
    >
      <path d="M 0.50505012,22.50505 11.50505,11.50505 0.50505012,0.50505012" />
    </svg>
  </button>
</template>

<style scoped lang="scss">
@import "../mixins.scss";

.frisbuy-button-arrow {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: 20px;
  height: 20px;

  border: none;
  background-color: transparent;

  align-items: center;

  svg {
    width: 100%;
    height: 100%;

    stroke: #6e6e6e;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: transparent;
  }

  &.--left {
    left: 26px;
    transform: translateY(-50%) scaleX(-1);
  }

  &.--right {
    right: 26px;
  }

  // media queries
  @media (max-width: $size-xs) {
    &.--adaptive {
      background-color: #ffffff;
      border-radius: 50%;

      svg {
        stroke: #5f5f5f;
        stroke-width: 5px;
        width: 6px;
        height: 9px;
      }
    }
  }
}
</style>

<script lang="ts">
import { PropType, defineComponent } from "vue";

export default defineComponent({
  emits: ["click"],

  props: {
    direction: {
      type: String as PropType<"left" | "right">,
      required: true,
    },

    weight: {
      type: String as PropType<"thin" | "normal">,
      required: false,
      default: "normal",
    },

    mode: {
      type: String as PropType<"static" | "adaptive">,
      required: false,
      default: "static",
    },
  },

  data() {
    return {};
  },

  methods: {
    clickHandler() {
      this.$emit("click");
    },
  },
});
</script>
